export const dailyLegLoadColumns: any[] = [
  {
    field: 'status',
    title: '',
    filter: 'icon',
    width: 50,
    minWidth: 50
  },
  {
    field: 'timeShow',
    title: 'Time',
    filter: 'text',
    width: 90,
  },
  {
    field: 'fore',
    // title used to be 'Fore (+stbd)' but now it's changed so it doesn't match the property name - but this is correct
    title: 'Heel (+stbd)',
    filter: 'numeric',
    allowNegative: true,
    width: 120
  },
  {
    field: 'port',
    // title used to be 'Port (+Aft)' but now it's changed so it doesn't match the property name - but this is correct
    title: 'Trim (+Aft)',
    filter: 'numeric',
    allowNegative: true,
    width: 120
  },
  {
    field: 'calculatedElevatedWeight',
    title: 'Calculated Elevated Weight',
    filter: 'numeric',
    allowNegative: true,
    preventDecimal: true,
    width: 130
  },
  {
    field: 'measuredElevatedWeight',
    title: 'Measured Elevated Weight',
    filter: 'numeric',
    allowNegative: false,
    width: 130
  },
  {
    field: 'comment',
    title: 'Comments',
    filter: 'text',
    allowNegative: false,
    width: 260
  },
  {
    field: 'totalTimeElevatedOnDateShow',
    title: 'Total Hours Elevated Today',
    filter: 'text',
    width: 120
  },
  {
    field: 'totalTimeElevatedAtLocationShow',
    title: 'Total Hours Elevated at Location',
    filter: 'text',
    width: 120
  },
];




// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-loads-log-component/daily-leg-loads-log-component.config.ts